module.exports = "/img/not-found.png?b1f75071ae53d2ee632c4bb87bcc2e81";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/not-found.png
// module id = EtaB
// module chunks = 66